$(document).ready(function() {

  if (!$('#reg_password').length || !$('#reg_password2').length) {
    return;
  }


  var $form = $('form.register');
  var $regPassword = $('#reg_password');
  var $regPassword2 = $('#reg_password2');

  $regPassword.on("input", checkPw);
  $regPassword2.on("input", checkPw);

  $form.append("<div class='msg-error'></div>");

  var submitBtn = $('input[name="register"]');

  submitBtn.attr('disabled', true);


  function checkPw(){
    if ( $regPassword2 ) {
      if ( $regPassword.val() == $regPassword2.val() ) {
        $form.find('.msg-error').html("");
        submitBtn.attr('disabled', false);
      } else {
        $form.find('.msg-error').html('<span class="woocommerce-error">Passwords do not match</span>');
        submitBtn.attr('disabled', true);
      }

    } else {
      $form.find('.msg-error').html("");
      submitBtn.attr('disabled', true);
    }
    return;
  }

});